import { render, staticRenderFns } from "./orgDetail.vue?vue&type=template&id=7f10fe5a&scoped=true"
import script from "./orgDetail.vue?vue&type=script&lang=js"
export * from "./orgDetail.vue?vue&type=script&lang=js"
import style0 from "./orgDetail.vue?vue&type=style&index=0&id=7f10fe5a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f10fe5a",
  null
  
)

export default component.exports